
import { RecipeCard } from "@/components/profile/RecipeCard";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

interface BaseItem {
  id: string;
  title: string;
  description: string | null;
  image_url: string | null;
  visibility: string;
  created_at: string;
}

interface Recipe extends BaseItem {
  type?: 'recipe';
  cuisine_type: string | null;
  likes_count: number;
}

interface Package extends BaseItem {
  type?: 'package';
  price: number;
}

type ContentItem = Recipe | Package;

interface RecipeSectionProps {
  title: string;
  recipes: ContentItem[];
  isSubscribed: boolean;
  profileUsername: string;
  isMobile: boolean;
}

export const RecipeSection = ({
  title,
  recipes,
  isSubscribed,
  profileUsername,
  isMobile,
}: RecipeSectionProps) => {
  if (!recipes.length) {
    return (
      <div>
        <h2 className="text-2xl font-semibold mb-4">{title}</h2>
        <p className="text-gray-500 text-center py-8">No {title.toLowerCase()} yet</p>
      </div>
    );
  }

  return (
    <div>
      <h2 className="text-2xl font-semibold mb-4">{title}</h2>
      <div className="relative">
        <Carousel className="w-full">
          <CarouselContent>
            {recipes.map((item) => (
              <CarouselItem key={item.id} className="md:basis-1/2 lg:basis-1/3">
                <RecipeCard
                  title={item.title}
                  description={item.description}
                  imageUrl={item.image_url}
                  visibility={item.visibility as 'public' | 'subscription'}
                  isSubscribed={isSubscribed}
                  profileUsername={profileUsername}
                  recipeId={item.id}
                  type={title.toLowerCase() === 'cookbooks' ? 'package' : 'recipe'}
                />
              </CarouselItem>
            ))}
          </CarouselContent>
          {!isMobile && (
            <>
              <CarouselPrevious className="hidden md:flex" />
              <CarouselNext className="hidden md:flex" />
            </>
          )}
        </Carousel>
      </div>
    </div>
  );
};
